import { render, staticRenderFns } from "./RecommendationTopProducts.vue?vue&type=template&id=187b1704"
import script from "./RecommendationTopProducts.vue?vue&type=script&lang=js"
export * from "./RecommendationTopProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports